import "./ImageSeparator.styles.scss";
import React from "react";

interface ImageSeparatorProps {
  image: string;
  alt: string;
}

const ImageSeparator = ({ image, alt }: ImageSeparatorProps) => {
  return (
    <div className="image-separator">
      <div className="image-separator__line" />
      <img className="image-separator__image" alt={alt} src={image} />
      <div className="image-separator__line" />
    </div>
  );
};

export default ImageSeparator;
